import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserData } from "../../services/apiAuthentication";
import { getCookie } from "../../utils/AccessCookies";

interface AuthState {
  isLoading: boolean;
  data: any;
  error: boolean;
}

const initialState: AuthState = {
  isLoading: false,
  data: null,
  error: false,
};

const AuthDetails = createAsyncThunk("fetchAuthData", async () => {
  const authData = getCookie("UserData");

  if (authData?.accessToken) {
    const response = await getUserData();
    return response;
  }
});

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logoutReducer: (state) => {
      return initialState; // Reset state to initial values
    },
  },
  extraReducers: (builder) => {
    builder.addCase(AuthDetails.pending, (state) => {
      state.isLoading = true;
      state.error = false;
    });
    builder.addCase(
      AuthDetails.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(AuthDetails.rejected, (state) => {
      state.isLoading = false;
      state.error = true;
    });
  },
});

export const { logoutReducer } = AuthSlice.actions;
export { AuthDetails };
export default AuthSlice.reducer;
